import { extractHtmlError, fetchWithXsrf, getAntiForgeryToken } from "@siisel/frontend-shared";
import { useState } from "react";
import type { PersonalHomePageFormViewModel } from "../types";

export default function PersonalHomePageFormApp(props: PersonalHomePageFormViewModel) {
  const [firstName, setFirstName] = useState(props.values.firstName);
  const [lastName, setLastName] = useState(props.values.lastName);
  const [email, setEmail] = useState(props.values.email);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  async function submit(root: HTMLElement | null) {
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    setErrorMessage(null);

    try {
      const formData = new FormData();
      const token = getAntiForgeryToken(root);
      if (token) {
        formData.append("__RequestVerificationToken", token);
      }

      formData.append("Id", String(props.values.id));
      formData.append("FirstName", firstName);
      formData.append("LastName", lastName);
      formData.append("Email", email);
      formData.append("saveAndClose", "false");

      const response = await fetchWithXsrf(props.submitUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "text/html"
        },
        body: formData
      });

      if (response.redirected) {
        window.location.href = response.url;
        return;
      }

      const html = await response.text();
      if (!response.ok) {
        throw new Error(html);
      }

      const validationMessage = extractHtmlError(html);
      if (validationMessage) {
        setErrorMessage(validationMessage);
        return;
      }

      window.location.reload();
    } catch (error) {
      const message = error instanceof Error ? error.message : "Ulozeni se nepodarilo.";
      setErrorMessage(message.includes("<") ? extractHtmlError(message) || message : message);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="forms-app personal-home-page-form-app">
      {errorMessage ? <div className="alert alert-danger">{errorMessage}</div> : null}
      <div className="base-form">
        <div className="row">
          <div className="col-lg-6">
            <div className="form-group">
              <label htmlFor="personal-home-first-name">{props.labels.firstName}</label>
              <input
                id="personal-home-first-name"
                className="form-control"
                value={firstName}
                disabled={isSubmitting}
                onChange={(event) => {
                  setFirstName(event.currentTarget.value);
                  setErrorMessage(null);
                }}
              />
            </div>
            <div className="form-group">
              <label htmlFor="personal-home-last-name">{props.labels.lastName}</label>
              <input
                id="personal-home-last-name"
                className="form-control"
                value={lastName}
                disabled={isSubmitting}
                onChange={(event) => {
                  setLastName(event.currentTarget.value);
                  setErrorMessage(null);
                }}
              />
            </div>
            <div className="form-group">
              <label htmlFor="personal-home-email">{props.labels.email}</label>
              <input
                id="personal-home-email"
                className="form-control"
                type="email"
                value={email}
                disabled={isSubmitting}
                onChange={(event) => {
                  setEmail(event.currentTarget.value);
                  setErrorMessage(null);
                }}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="form-group">
              <label>{props.labels.subscriberType}</label>
              <span className="text-as-ro-input">{props.values.subscriberType}</span>
            </div>
            <div className="form-group">
              <label>{props.labels.roles}</label>
              <div className="ro-roles">{props.values.roles.join(", ")}</div>
            </div>
            <div className="form-group">
              <label>{props.labels.status}</label>
              <span className="text-as-ro-input">{props.values.status}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="panel-footer">
        <button
          type="button"
          className="btn btn-success btn-sm"
          disabled={isSubmitting}
          onClick={(event) => void submit(event.currentTarget.closest(".forms-app"))}
        >
          <em className="fa fa-save"></em>
          {isSubmitting ? `${props.submitText}...` : props.submitText}
        </button>
      </div>
    </div>
  );
}
